if (!customElements.get('product-card')) {
  class ComponentProductCard extends HTMLElement {
    constructor() {
      super()
      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      this.swatches = this.querySelector('.inline-swatch-group')
      if(this.quickViewBtn)
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))

      if(this.swatches){
        this.swatches.querySelectorAll('input').forEach((input)=>{
          input.addEventListener('change', this.onSwatchChange.bind(this));
          input.addEventListener('change', this.onSwatchChangeTest.bind(this));
        })
      }
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onSwatchChange() {
      var checkedOption = this.querySelector('.inline-swatch-group input:checked')
      var variantImg = checkedOption.dataset.variantImg;
      var variantHoverImg = checkedOption.dataset.variantHoverImg;

      var variantUrl = checkedOption.dataset.variantUrl;

      var priceFinal = checkedOption.dataset.priceFinal;
      var priceCompare = checkedOption.dataset.priceCompare;
      var extraDetail = checkedOption.dataset.extraDetail;

      this.querySelectorAll('.product-card-url').forEach(function(e){
        e.setAttribute('href', variantUrl)
      });

      if (this.quickViewBtn)
        this.quickViewBtn.setAttribute('data-url', variantUrl)
      this.querySelector('.final').innerHTML = priceFinal
      if(this.querySelector('.from')) {
        this.querySelector('.from').style.display = "none"
      }
      if(priceCompare) {
        this.querySelector('.compare').innerHTML = priceCompare
        this.querySelector('.compare').style.display = "block"
      } else {
        this.querySelector('.compare').style.display = "none"
      }
      if(variantImg) {
        this.querySelector('.img.main')?.setAttribute('srcset', variantImg)
      }
      if(variantHoverImg) {
        var hoverImage = this.querySelector('.img.hover-img');
        hoverImage.setAttribute('srcset', variantHoverImg);

        if (!hoverImage.complete) {
          hoverImage.style.opacity = '0';
          hoverImage.addEventListener('load', () => {
            hoverImage.style = ''
          })         
        }        
      }

      if(extraDetail){
        this.querySelector('.extra-detail').innerHTML = extraDetail;
      }

    }

    onSwatchChangeTest() {
      const checkedOption = this.querySelector('.inline-swatch-group input:checked');
      if(checkedOption?.value){
        this.querySelectorAll(`.carousel-slide > img[alt*='${checkedOption?.value.replace(",","+")}']:not(.hide${checkedOption.value.includes(",") ? "": ",[alt*='+']"})`).forEach(img => {
          if(img.getAttribute("alt").includes(`${checkedOption?.value.replace(",","+")}-1`) || img.getAttribute("alt").includes(`${checkedOption?.value.replace(",","+")}^1`)){
            img.parentElement.style.display = 'flex'
          }
          img.parentElement.setAttribute("data-variant-selected","")
        })
        this.querySelectorAll(`.carousel-slide > img:not([alt*='${checkedOption?.value.replace(",","+")}'], .hide)`).forEach(img => {
          img.parentElement.removeAttribute("data-variant-selected")
          img.parentElement.style.display = 'none'
        })
      }
    }
  }   

  customElements.define('product-card', ComponentProductCard);
}